module.exports = __webpack_public_path__ + "static/media/viewer-light.06a4c111.svg";